import { render, staticRenderFns } from "./SalesDeals.vue?vue&type=template&id=dbc13cec&scoped=true&"
import script from "./SalesDeals.vue?vue&type=script&lang=js&"
export * from "./SalesDeals.vue?vue&type=script&lang=js&"
import style0 from "./SalesDeals.vue?vue&type=style&index=0&id=dbc13cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc13cec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
